<template>
  <v-container class="px-10">
    <v-row justify="center">
      <v-col md="12">
        <v-btn color="success" class="my-9 text-capitalize" @click="() => {item = null; readMode = false; display = true}"
        >{{ $t('hr.variation.add') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col class="mt-8">
        <h3 class="mb-2">{{ $router.currentRoute.name }}</h3>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          class="mb-3"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table :dark="$store.state.isDarkMode"
          :headers="headers"
          :search="search"
          id="table"
          :items="data"
          :loading="$store.state.variations.loading"
          style="border: 1px solid #999"
          :options.sync="$store.state.variations.options"
          :server-items-length="$store.state.variations.serverTotal"
          disable-sort
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-center">
              <v-icon
                color="red"
                class="mx-2"
                style="cursor: pointer"
                @click="handleDelete(item)"
              >mdi-delete
              </v-icon>
              <v-icon
              color="blue"
              class="mx-2"
              style="cursor: pointer"
              @click="handleEdit(item)"
            >mdi-pencil
            </v-icon>
              <v-icon
                color="blue"
                class="mx-2"
                style="cursor: pointer"
                @click="handleDisplay(item)"
              >mdi-eye
              </v-icon>
            </div>

          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <VariationModal v-model="display"  :item="item" :read-mode="readMode"></VariationModal>
  </v-container>
</template>
<script>
import axios from "axios";
import {mapActions, mapGetters} from "vuex";
import VariationModal from "@/views/dashboard/modules/HR/variations/VariationModal.vue";

export default {
  components: {VariationModal},
  data() {
    return {
      readMode: false,
      search: '',
      display: false,
      item: null,
    };
  },
  mounted() {
    this.fetch()
  },
  computed: {
    ...mapGetters({
      data: 'variations/data',
      headers: 'variations/headers'
    })
  },
  watch: {
    "$store.state.variations.options": function () {
      this.fetch()
    },
  },
  methods: {
    ...mapActions({
      fetch: 'variations/fetch',
      delete: 'variations/delete'
    }),
    handleDisplay(item) {
      this.item = item
      this.readMode = true
      this.display = true
    },
    async handleDelete(item) {
      await this.delete(item.id)
    },
    handleEdit(item) {
      this.item = item
      this.readMode = false
      this.display = true
    },
  },
};
</script>
<style scoped>
#table >>> th, #table >>> td {
  text-align: center !important;
}
</style>
